const menu_header = (callback) => {
   if (document.readyState != "loading") callback();
   else document.addEventListener("DOMContentLoaded", callback);
};

menu_header(() => {
   const menuOpenButton = document.querySelector('.js-open-menu');
   const headerMobile = document.querySelector('.js-header-mobile');
   const body = document.querySelector('body');

   if (menuOpenButton && headerMobile && body) {
      menuOpenButton.addEventListener('click', function () {
         menuOpenButton.classList.toggle('active');
         headerMobile.classList.toggle('active');
         body.classList.toggle('overflow-hidden');
      });
   }
});